var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading-indicator',[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header":_vm.$t('transactions.transaction')}},[_c('orders',{ref:"orders"})],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }